import { render, staticRenderFns } from "./QuickSearchMetalSupplier.vue?vue&type=template&id=2d446650&scoped=true"
import script from "./QuickSearchMetalSupplier.vue?vue&type=script&lang=js"
export * from "./QuickSearchMetalSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d446650",
  null
  
)

export default component.exports